import React from 'react'
import { useIntl } from 'react-intl'

import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { rem } from 'polished'
import OfferTypesCarousel from 'home/components/BrowseOfferTypes/OfferTypesCarousel'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

const TravelPane = styled(Group)`
  padding: ${rem(24)} 0;
  background: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0;
  }
`

function Travel() {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'dMIV47Pczr',
    defaultMessage: 'Everything travel, all in the one place',
    description: 'About us page - travel section heading on the about us page',
  })

  return (
    <TravelPane direction="vertical" gap={20}>
      <LayoutContainer>
        <Heading variant="heading2">
          {heading}
        </Heading>
      </LayoutContainer>
      <OfferTypesCarousel />
    </TravelPane>
  )
}

export default Travel
